var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#F4511E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_187_3593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.915 4.0071L4.195 5.2821C4.08156 5.30366 4 5.40679 4 5.5221V14.4771C4 14.5924 4.08156 14.6955 4.195 14.7171L10.915 15.9921C10.93 15.9949 10.945 15.9996 10.96 15.9996C11.0153 15.9996 11.0669 15.9827 11.11 15.9471C11.1653 15.9012 11.2 15.8309 11.2 15.7596V4.2396C11.2 4.16835 11.1653 4.09804 11.11 4.0521C11.0547 4.00616 10.9853 3.99398 10.915 4.0071ZM11.68 5.4396V7.6146C11.7588 7.60335 11.8384 7.5996 11.92 7.5996V9.2796H13.6C13.6 10.2077 12.8481 10.9596 11.92 10.9596C11.8384 10.9596 11.7588 10.9559 11.68 10.9446V12.3996H13.6V12.8796H11.68V14.5596H15.28C15.5444 14.5596 15.76 14.344 15.76 14.0796V5.9196C15.76 5.65523 15.5444 5.4396 15.28 5.4396H11.68ZM12.64 6.8796C13.5681 6.8796 14.32 7.63148 14.32 8.5596H12.64V6.8796ZM5.9575 7.7571H7.54C8.67156 7.7571 9.2425 8.23523 9.2425 9.1896C9.2425 9.64054 9.07938 10.0062 8.755 10.2846C8.43063 10.563 7.99281 10.7046 7.45 10.7046H6.97V12.2496H5.9575V7.7571ZM6.97 8.5371V9.9321H7.3675C7.90563 9.9321 8.1775 9.69867 8.1775 9.2271C8.1775 8.76585 7.90563 8.5371 7.3675 8.5371H6.97Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_187_3593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.2f73cfc8da58d851f59738d9caa5f2ea.svg";
export { ForwardRef as ReactComponent };